import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { themeSpace } from 'styles/themeUtils';

const SectionTitle = styled(Typography)`
  margin-bottom: ${themeSpace(2.5)};
`;

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;
